"use client";

import { useEffect } from "react";
import { useRecentlyViewed } from "@/components/RecentlyViewed/useRecentlyViewed";

export default function SaveRecentlyViewed(item) {
  const { type } = item;
  const { addItem } = useRecentlyViewed(type);

  useEffect(() => {
    addItem(item);
  }, [item]);

  return <></>;
}
